<template>
  <div class="contentContainer">
    <!-- Header -->
    <div class="Toolbar">
      <div class="Toolbar-Left" @click="onClickGoBack">
        <font-awesome-icon :icon="['fal', 'angle-left']" size="2x" />
        <span class="u-ml10 TextWithIcon">注文一覧</span>
      </div>

      <div class="Toolbar-Center">
        <div class="Toolbar-Center-Text">
          {{ order.customer && order.customer.name }} 様の注文内容
        </div>
      </div>
    </div>
    <!-- Sub Header -->
    <div class="Toolbar-Right clearfix">
      <div class="Toolbar-Right-Div1 clearfix">
        <el-button
          class="request-btn-padding"
          type="button"
          v-if="isCancellable"
          @click="cancelDialogVisible = true"
          >注文キャンセル依頼</el-button
        >
        <div
          v-if="
            (primaryOrder &&
              primaryOrder.status &&
              primaryOrder.status.code === 'CANCEL_REQUEST') ||
              cancelOrder
          "
          class="cancel-request"
        >
          注文キャンセル依頼中
        </div>
      </div>
      <div class="Toolbar-Right-Div2" id="order-detail">
        <el-select :value="selectValue" class="selectbtn">
          <el-option value="1">
            <el-button
              type="text"
              @click="onClickPrint()"
              id="print-btn"
              class="black-text"
              >位牌原稿確認</el-button
            >
          </el-option>

          <el-option value="2">
            <el-button
              id="operation-btn"
              type="text"
              :class="isEditable ? 'black-text' : ''"
              :disabled="!isEditable"
              @click="_onClickEdit()"
            >
              編集
            </el-button>
          </el-option>

          <el-option value="3">
            <el-button
              id="operation-btn"
              type="text"
              class="black-text"
              @click="openOrderManagementDialog()"
            >
              注文管理
            </el-button>
          </el-option>

          <el-option value="4">
            <el-button
              type="text"
              id="operation-btn"
              @click="onClickDelete()"
              :class="isDeletable ? 'red-text' : ''"
              :disabled="!isDeletable"
              >削除</el-button
            >
          </el-option>
        </el-select>

        <el-button
          class="sendbtn"
          type="primary"
          @click="sendOrderVisibleFunc"
          v-if="isClientUser && isSubmitable && primaryOrder && primaryOrder.detail && primaryOrder.detail.product"
          :loading="sendOrderVisible ? isLoading : false"
          :disabled="
            isSuspensionOrder || isHoshiExceptionOrder || isNoSignature || isSendOrderDisabled
          "
          >注文送信</el-button
        >

        <el-button
          class="sendcompletebtn"
          type="secondary"
          @click="sendOrderVisible = true"
          v-if="isShippedFamily"
          :disabled="true"
          >注文送信済み</el-button
        >
        <SignatureInput
          style="margin-left:5px"
          @onSubmit="onSubmitSignature"
          :signature="primaryOrder && primaryOrder.detail && primaryOrder.detail.signature"
          :isEditable="primaryOrder && primaryOrder.detail && primaryOrder.detail.signature === null"
        />
      </div>

      <div class="order-dialog">
        <!-- Order Cancel Confirm -->
        <el-dialog :visible.sync="cancelDialogVisible" width="35%" center>
          <span class="dialog-text">この注文のキャンセルを依頼しますか？</span>
          <span slot="footer" class="dialog-footer">
            <el-button class="cancel-btn" @click="cancelDialogVisible = false"
              >キャンセル</el-button
            >
            <el-button class="request-btn redText" @click="requestCancelOrder()"
              >依頼する</el-button
            >
          </span>
        </el-dialog>

        <!-- Order Delete Confirm -->
        <el-dialog :visible.sync="centerDialogVisible" width="35%" center>
          <span class="dialog-text">この注文を削除しますか？</span>
          <span slot="footer" class="dialog-footer">
            <el-button class="cancel-btn" @click="centerDialogVisible = false"
              >キャンセル</el-button
            >
            <el-button class="request-btn redText" @click="deleteOrder()"
              >削除する</el-button
            >
          </span>
        </el-dialog>

        <!-- Order Send Confirm -->
        <el-dialog
          :visible.sync="sendOrderVisible"
          width="35%"
          center
          :close-on-click-modal="!isLoading"
          @closed="closedSendOrderVisible"
        >
          <span class="dialog-text">注文を送信しますか？</span>

          <OrderFormExpectedShippingDatePicker
            ref="orderFormStep6OrderConfirmTabForm"
          />
          <span slot="footer" class="dialog-footer">
            <el-button
              class="cancel-btn"
              @click="sendOrderModalCancel"
              :disabled="isLoading"
              >キャンセル</el-button
            >
            <el-button
              :loading="isLoading"
              class="request-btn"
              @click="sendOrder()"
              :disabled="!hasExpectedShippingDate"
              >{{ isLoading ? "送信中" : "はい" }}</el-button
            >
          </span>
        </el-dialog>

        <!-- Order Management -->
        <el-dialog
          :visible.sync="orderManagementDialogVisible"
          width="70%"
          center
        >
          <div
            class="order-management-dialog-body"
            v-loading="orderManagementLoading"
          >
            <span class="dialog-text">戒名の一覧</span>
            <div class="order-management-list u-pb20">
              <div
                v-for="managedOrder in managedOrders"
                :key="managedOrder.id"
                class="order-management-item"
              >
                <div
                  class="order-management-preview-frame u-mb10"
                  :class="{
                    'order-management-preview-frame--current':
                      isDisplayedManagedOrderInManagementModal(managedOrder),
                  }"
                >
                  <TabletPreview
                    :order="managedOrder"
                    :frontColor="(managedOrder.fontColors && managedOrder.fontColors[1]) || { name: '金色', colorCode: 'yellow' }"
                    :backColor="(managedOrder.fontColors && managedOrder.fontColors[0]) || { name: '白', colorCode: 'white' }"
                    :is-show-description="false"
                  />
                </div>
                <el-button
                  type="primary"
                  class="u-mt10"
                  @click="onClickShowManagedOrder(managedOrder.id)"
                >
                  表示する
                </el-button>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <div v-if="isSuspensionOrder" class="alertNoteBox">
      <el-alert
        title="注文送信できません"
        description="商品選択保留中の為、注文送信できません。商品を選択してから再度注文送信してください。"
        type="warning"
        show-icon
        :closable="false"
      >
      </el-alert>
    </div>
    <div v-if="isHoshiExceptionOrder" class="alertNoteBox">
      <el-alert
        title="注文送信できません"
        description="保志以外へのご注文のため注文送信できません。"
        type="warning"
        show-icon
        :closable="false"
      >
      </el-alert>
    </div>
    <div v-if="isSendOrderDisabled" class="alertNoteBox">
      <el-alert
        title="注文送信できません"
        :description="errorMessage"
        type="error"
        show-icon
        :closable="false"
      >
      </el-alert>
    </div>
    <!-- Status and Author Information -->
    <div class="Flow">
      <div
        class="informationTableContainer"
        v-if="
          order.statusAndAuthorInformation &&
            order.statusAndAuthorInformation.length
        "
      >
        <table class="statusAndAuthorTable">
          <tr v-for="item in order.statusAndAuthorInformation" :key="item[0]">
            <th class="Text">{{ item[0] }}</th>
            <td class="Text">{{ item[1] }}</td>
          </tr>
        </table>
      </div>
    </div>
    <!-- Contents -->
    <div class="Contents" v-if="isValidOrderAvailable">
      <!-- Product Information -->
      <p class="preview-title">商品</p>
      <div class="preview" v-if="order.detail.product">
        <img :src="order.detail.product.imageUrl[0]" class="tablet" />
        <div v-if="order.detail.product">
          <p class="title product-data"></p>
          <p class="title product-data data-inline">
            {{ order.detail.product.name }}
          </p>
          <p class="title product-data data-inline">
            {{ getSizeText() }}
          </p>
        </div>
      </div>
      <div class="preview" v-else>
        <p>商品選択なし</p>
      </div>
      <!-- Preview -->
      <div class="preview">
        <p class="preview-title">原稿</p>
        <TabletPreview
          :order="order"
          :frontColor="(order.fontColors && order.fontColors[1]) || { name: '金色', colorCode: 'yellow' }"
          :backColor="(order.fontColors && order.fontColors[0]) || { name: '白', colorCode: 'white' }"
          :is-show-description="true"
        />
      </div>

      <p class="preview-title">レイアウト</p>

      <!-- 確定後: 校了済みレイアウトのみ表示 -->
      <div class="layout-images-section" v-show="isOrderConfirmed && approvedLayoutImageForDisplay">
        <div class="approved-layout-confirmed">
          <img
            :src="approvedLayoutImageForDisplay ? approvedLayoutImageForDisplay.resolvedUrl : ''"
            class="approved-layout-confirmed-img"
            @click="approvedLayoutImageForDisplay && openLayoutImageDialog(approvedLayoutImageForDisplay)"
          />
        </div>
      </div>

      <!-- 確定前: レイアウト画像一覧 + 校了ボタン -->
      <div class="layout-images-section" v-show="layoutImagesForDisplay.length > 0 && !isOrderConfirmed">
        <p class="layout-description">確認・校了するレイアウトを選択してください</p>
        <div class="layout-images-grid">
          <div
            v-for="img in layoutImagesForDisplay"
            :key="img.id"
            class="layout-image-card"
            :class="{ 'layout-image-approved': img.isApproved }"
            @click="openLayoutImageDialog(img)"
          >
            <div class="layout-image-card-inner">
              <div class="layout-image-thumb-wrapper">
                <img :src="img.resolvedUrl" v-if="img.resolvedUrl" class="layout-image-thumb" />
              </div>
              <div v-if="img.isApproved" class="layout-image-approved-badge" title="校了済み">
                <i class="el-icon-check"></i>
              </div>
            </div>
            <!-- <p class="layout-image-filename">{{ img.fileName || img.imageKey }}</p> -->
          </div>
        </div>
      </div>

      <!-- Layout Image Dialog -->
      <el-dialog
        :visible.sync="layoutImageDialogVisible"
        width="80%"
        :show-close="false"
        class="layout-image-dialog"
      >
        <template slot="title">
          <div class="layout-image-dialog-header">
            <span class="layout-image-dialog-header-title" @click="layoutImageDialogVisible = false">
              <i class="el-icon-circle-close"></i>
              <span class="layout-image-dialog-header-label">レイアウト</span>
            </span>
          </div>
        </template>
        <div v-if="selectedLayoutImage" class="layout-image-dialog-content">
          <div class="layout-image-dialog-top-row">
            <p class="layout-image-dialog-filename">{{ selectedLayoutImage.fileName || selectedLayoutImage.imageKey }}</p>
            <template v-if="!isOrderConfirmed">
              <el-button
                v-if="selectedLayoutImage.isApproved === true"
                type="success"
                disabled
              >校了済み</el-button>
              <el-button
                v-else
                type="primary"
                @click="confirmApproveLayout"
              >このレイアウトで校了する</el-button>
            </template>
            <el-button
              v-else-if="selectedLayoutImage.isApproved === true"
              type="success"
              disabled
              size="small"
            >校了済み</el-button>
          </div>
          <div class="layout-image-dialog-preview">
            <img :src="selectedLayoutImage.resolvedUrl" v-if="selectedLayoutImage.resolvedUrl" class="layout-image-full" />
          </div>
        </div>
        <!-- Thumbnails at bottom -->
        <div class="layout-image-dialog-thumbs">
          <div
            v-for="img in layoutImagesForDisplay"
            :key="'dialog-' + img.id"
            class="layout-image-dialog-thumb-item"
            :class="{ 'layout-image-dialog-thumb-selected': selectedLayoutImage && selectedLayoutImage.id === img.id }"
            @click="selectLayoutImage(img)"
          >
            <img :src="img.resolvedUrl" v-if="img.resolvedUrl" />
          </div>
        </div>
      </el-dialog>

      <!-- Layout Approve Confirm Dialog -->
      <el-dialog
        :visible.sync="layoutApproveConfirmDialogVisible"
        width="400px"
        center
      >
        <span class="dialog-text" v-if="selectedLayoutImage">
          レイアウト「{{ selectedLayoutImage.fileName || selectedLayoutImage.imageKey }}」を校了にしますか？
        </span>
        <span slot="footer">
          <el-button @click="layoutApproveConfirmDialogVisible = false">キャンセル</el-button>
          <el-button
            type="primary"
            :loading="isApprovingLayout"
            @click="approveLayoutImage"
          >校了する</el-button>
        </span>
      </el-dialog>

      <!-- Detail Information -->
      <div class="Flow">
        <p class="preview-title">注文情報</p>
        <InformationTable
          class="orderInformation"
          title="店舗情報"
          :source="order.clientGroupInformation"
        />
        <InformationTable
          class="orderInformation"
          title="お客様情報"
          :source="order.customerInformation"
        />
        <InformationTable
          title="自由項目"
          :source="order.customFieldInformation"
        />
        <InformationTable
          title="商品情報"
          :source="order.categoryInformation"
        />
        <InformationTableChild :source="order.productInformation" />
        <InformationTable
          title="原稿情報"
          :source="order.orderTypeInformation"
        />
        <InformationTableChild :source="order.typographyInformation" />
        <InformationTable
          title="詳細情報"
          :source="order.detailInformation"
        />
        <div
          class="UserUploadImgTitleConfirm"
          v-if="order.detail.customFamilyEmblemUrl"
        >
          ユーザー選択画像(家紋)
        </div>
        <img
          v-if="order.detail.customFamilyEmblemUrl"
          title="ユーザー選択画像(家紋)"
          class="UserUploadImgConfirm"
          :src="customFamilyEmblemImg"
          alt
        />
        <div
          class="UserUploadImgTitleConfirm"
          v-if="order.detail.customSanskritCharacterUrl"
        >
          ユーザー選択画像(梵字)
        </div>
        <img
          v-if="order.detail.customSanskritCharacterUrl"
          title="ユーザー選択画像(梵字)"
          class="UserUploadImgConfirm"
          :src="customSanskritCharacterImg"
          alt
        />
        <div
          class="UserUploadImgTitleConfirm"
          v-if="order.detail.customSanskritCharacterBackUrl"
        >
          ユーザー選択画像(裏梵字)
        </div>
        <img
          v-if="order.detail.customSanskritCharacterBackUrl"
          title="ユーザー選択画像(裏梵字)"
          class="UserUploadImgConfirm"
          :src="customSanskritCharacterBackImg"
          alt
        />

        <InformationTable title="その他" :source="order.otherInformation" />

        <InformationTableImage
          title="注意文字"
          :source="order.itaijiPointsInformation"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import { Loading } from "element-ui";

import Order from "@/entities/order.entity";

import InformationTable from "@/components/InformationTable";
import InformationTableChild from "@/components/InformationTableChild";
import InformationTableImage from "@/components/InformationTableImage";
import TabletPreview from "@/components/Common/TabletPreview.vue";
import SignatureInput from "@/components/SignatureInput";

import OrderFormExpectedShippingDatePicker from "@/components/OrderFormExpectedShippingDatePicker.module";

import OrderUsecase from "@/usecases/order.usecase";
import FileUsecase from "@/usecases/file.usecase";
// import ProductUsecase from "@/usecases/product.usecase";
// import OrderFormUsecase from "@/usecases/orderForm.usecase";
// import UsecaseFactory from "@/usecases/usecase.factory.js";

import Auth from "@/services/auth.service";

export default {
  components: {
    InformationTable,
    InformationTableChild,
    InformationTableImage,
    TabletPreview,
    SignatureInput,
    OrderFormExpectedShippingDatePicker,
  },
  data () {
    return {
      centerDialogVisible: false,
      cancelDialogVisible: false,
      productInformation: [],
      customFamilyEmblemImg: "",
      customFamilyEmblemUrl: "",
      customSanskritCharacterImg: "",
      customSanskritCharacterUrl: "",
      customSanskritCharacterBackImg: "",
      getColumns: [],
      columnsInfo: [],
      cancelOrder: false,
      sendOrderVisible: false,
      orderManagementDialogVisible: false,
      orderManagementLoading: false,
      orderManagementOrders: [],
      selectValue: "操作",
      isLoading: false,
      points: [],
      missingFields: [],
      isOrderConfirmed: false,
      layoutImagesForDisplay: [],
      layoutImageDialogVisible: false,
      layoutApproveConfirmDialogVisible: false,
      selectedLayoutImage: null,
      isApprovingLayout: false,
    };
  },
  props: {
    orderdata: {
      type: Object,
      default: () => ({}),
    },
    /** OrderDetail から渡す解決済み primary（子画面では親の実体など） */
    primaryOrderData: {
      type: Object,
      default: null,
    },
  },
  async created () {},
  mounted () {
  },
  computed: {
    ...mapState({
      form: state => state.orderForm.detailInput,
      getOrderId: state => state.orderForm.setOrderId,
    }),
    order: {
      get () {
        this.getCustomImg();
        return this.orderdata;
      },
      set (value) {
        this.orderdata = value;
      },
    },
    primaryOrder () {
      const src = this.primaryOrderData;
      if (src && src.id) {
        return src;
      }
      return this.order;
    },
    currentUser () {
      return this.$store.state.user;
    },
    isClientUser () {
      return this.currentUser && Auth.isClientUser(this.currentUser.role);
    },
    isValidOrderAvailable () {
      return this.order instanceof Order;
    },
    isDeletable () {
      const order = this.primaryOrder;
      return !!(order && order.isDeletable);
    },
    isEditable () {
      const { currentUser } = this;
      const orderClient = this.order.client;

      // computed で処理する関係上、order の用意がされてからでないと order.entity(.js) 内の処理を呼び出せない
      const isEditableStatus = this.order.isEditableStatus || false;
      const isEditableAuthority = this.order.isEditableAuthority ? this.order.isEditableAuthority(orderClient, currentUser) : false;

      return isEditableStatus && isEditableAuthority;
    },
    isParentOrder () {
      // eslint-disable-next-line
      return this.order.parentOrder ? false : true;
    },
    managedOrders () {
      return this.orderManagementOrders;
    },
    isSubmitable () {
      const o = this.primaryOrder;
      return !!(o && o.isSubmitable);
    },
    isCancellable () {
      const o = this.primaryOrder;
      return !!(o && o.isCancellable);
    },
    /** 注文送信済み表示（親のステータス基準・子詳細でも親が発送済みなら表示） */
    isShippedFamily () {
      const o = this.primaryOrder;
      return !!(o && o.isShipped);
    },
    // 保留中の注文
    isSuspensionOrder () {
      const order = this.primaryOrder;
      return (
        order &&
        order.detail &&
        order.detail.product &&
        order.detail.product.id === "99101"
      );
    },
    // 保志以外の注文
    isHoshiExceptionOrder () {
      const order = this.primaryOrder;
      return (
        order &&
        order.detail &&
        order.detail.product &&
        order.detail.product.id === "99201"
      );
    },
    isNoSignature () {
      const order = this.primaryOrder;
      return order && order.detail && order.detail.signature === null;
    },
    isSendOrderDisabled () {
      return this.missingFields.length > 0;
    },
    errorMessage () {
      if (this.missingFields.length === 0) return "";
      return `未設定の項目があるため注文送信できません。「${this.missingFields.join("、")}」`;
    },
    canApproveLayout () {
      if (!this.order || !this.order.status) return false;
      const statusCode = this.order.status.code;
      const disallowed = ["DRAFT", "ORDER_REQUEST", "PROCESSING", "SHIPPED"];
      return !disallowed.includes(statusCode);
    },
    isStatusConfirmedOrLater () {
      if (!this.order || !this.order.status) return false;
      const code = this.order.status.code;
      return code === "CONFIRMED" || code === "SHIPPED";
    },
    approvedLayoutImageForDisplay () {
      return this.layoutImagesForDisplay.find(img => img.isApproved) || null;
    },
    // 希望納期が入力されているかの確認
    hasExpectedShippingDate () {
      return !!(
        this.form &&
        this.form.expectedShippingDate
      );
    },
  },
  watch: {
    primaryOrder: {
      deep: true,
      immediate: true,
      handler: function () {
        this.getPointsImages();
        this.updateMissingFields();
        this.loadLayoutImages();
        // CONFIRMED / SHIPPED の場合は校了済みレイアウトのみ表示
        var code = this.order && this.order.status ? this.order.status.code : "";
        this.isOrderConfirmed = (code === "CONFIRMED" || code === "SHIPPED");
      },
    },
  },
  methods: {
    ...mapActions({
      resetDetailInput: "orderForm/resetDetailInput",
    }),
    updateMissingFields () {
      const order = this.primaryOrder;
      this.missingFields = [];
      if (!order || !order.detail) {
        return;
      }
      if (!order.clientGroup || !order.clientGroup.id) this.missingFields.push("店舗");
      if (!order.detail.productVariation) this.missingFields.push("商品");
      if (!order.detail.typography || !order.detail.typography.printType) this.missingFields.push("彫書");
      if (!order.detail.typography || !order.detail.typography.font) this.missingFields.push("書体");
      if (order.orderType === "マインドアルテ") {
        if (!order.detail.typography || !order.detail.typography.textColorFront) this.missingFields.push("文字色");
      } else {
        if (!order.detail.typography || !order.detail.typography.textColorFront || !order.detail.typography.textColorBack) this.missingFields.push("文字色");
      }
    },
    async getCustomImg () {
      if (
        this.orderdata &&
        this.orderdata.detail &&
        this.orderdata.detail.customFamilyEmblemUrl
      ) {
        this.customFamilyEmblemImg = await usecase.file.fetchURL(
          this.orderdata.detail.customFamilyEmblemUrl
        );
      }
      if (
        this.orderdata &&
        this.orderdata.detail &&
        this.orderdata.detail.customSanskritCharacterUrl
      ) {
        this.customSanskritCharacterImg = await usecase.file.fetchURL(
          this.orderdata.detail.customSanskritCharacterUrl
        );
      }
      if (
        this.orderdata &&
        this.orderdata.detail &&
        this.orderdata.detail.customSanskritCharacterBackUrl
      ) {
        this.customSanskritCharacterBackImg = await usecase.file.fetchURL(
          this.orderdata.detail.customSanskritCharacterBackUrl
        );
      }
    },
    getPointsImages () {
      this.points = [];
      if (this.order.itaijiPoints) {
        this.order.itaijiPoints.map(key => {
          return usecase.file.fetchURL(key).then(url => {
            this.points.push(url);
          });
        });
      }
    },
    async loadLayoutImages () {
      const order = this.order;
      if (!order || !order.layoutImages || !order.layoutImages.length) {
        this.layoutImagesForDisplay = [];
        return;
      }
      const images = await Promise.all(
        order.layoutImages.map(async (img) => {
          let resolvedUrl = "";
          try {
            resolvedUrl = await usecase.file.fetchURL(img.imageKey);
          } catch (e) {
            console.error("Failed to resolve layout image URL:", e);
          }
          return {
            ...img,
            resolvedUrl,
          };
        })
      );
      this.layoutImagesForDisplay = images;
    },
    openLayoutImageDialog (img) {
      this.selectedLayoutImage = img;
      this.layoutImageDialogVisible = true;
    },
    selectLayoutImage (img) {
      this.selectedLayoutImage = img;
    },
    confirmApproveLayout () {
      this.layoutApproveConfirmDialogVisible = true;
    },
    async approveLayoutImage () {
      if (!this.selectedLayoutImage) return;
      this.isApprovingLayout = true;
      try {
        await usecase.order.approveLayoutImage({
          orderId: this.order.id,
          layoutImageId: this.selectedLayoutImage.id,
        });
        this.layoutApproveConfirmDialogVisible = false;
        this.layoutImageDialogVisible = false;
        // Reload order to reflect approval state
        this.$emit("reload");
      } catch (e) {
        alert("校了に失敗しました。再度お試しください。");
        console.error(e);
      } finally {
        this.isApprovingLayout = false;
      }
    },
    onClickAction (command) {
      this[command]();
    },
    onClickGoBack () {
      const { $router } = this;
      const localData = JSON.parse(localStorage.getItem("vuex"));
      if (localData.user.role === "ADMIN") {
        $router.push("/admin/home");
      } else {
        $router.push("/home");
      }
    },
    async syncOrder () {
      // get order ID
      const orderId = this.$route.params.id;
      // get order
      const order = await usecase.order.getOrder({ orderId });
      this.$emit("onChangeOrder", order);
    },
    // FIXME:
    // - reduce duplication
    async onClickPrint () {
      const { $router } = this;
      this.$store.commit("orderForm/setOrderId", this.order.id);
      // go to print page
      $router.push("/orderconfirm");
    },
    _onClickEdit () {
      // set the current value
      this.selectValue = "編集";
      // transition to edit screen
      if (this.order.parentOrder) {
        this.$router.push(`/orders/${this.order.id}/edit/step4`);
      } else {
        this.$router.push(`/orders/${this.order.id}/edit/step1`);
      }
    },
    async loadOrderManagementOrders () {
      const currentOrderId = this.$route.params.id;
      if (!currentOrderId) {
        return [];
      }

      const fromDetail =
        this.order &&
        this.order.id &&
        String(this.order.id) === String(currentOrderId)
          ? this.order
          : null;

      const currentOrder =
        fromDetail || (await usecase.order.getOrder({ orderId: currentOrderId }));
      if (!currentOrder) {
        return [];
      }

      const parentOrderId =
        currentOrder.parentOrder && currentOrder.parentOrder.id
          ? currentOrder.parentOrder.id
          : currentOrder.id;
      const parentOrder =
        parentOrderId === currentOrder.id
          ? currentOrder
          : await usecase.order.getOrder({ orderId: parentOrderId });
      if (!parentOrder) {
        return [];
      }

      const childOrders = Array.isArray(parentOrder.childOrders)
        ? parentOrder.childOrders
        : [];
      return [parentOrder, ...childOrders].map(order =>
        order instanceof Order ? order : Order.fromJson(order)
      );
    },
    async openOrderManagementDialog () {
      this.orderManagementDialogVisible = true;
      this.orderManagementLoading = true;
      try {
        this.orderManagementOrders = await this.loadOrderManagementOrders();
      } finally {
        this.orderManagementLoading = false;
      }
    },
    async onClickShowManagedOrder (orderId) {
      if (!orderId) {
        return;
      }
      if (orderId === this.$route.params.id) {
        this.orderManagementDialogVisible = false;
        return;
      }
      this.$router.push(`/orders/${orderId}`);
      this.orderManagementDialogVisible = false;
    },
    isDisplayedManagedOrderInManagementModal (managedOrder) {
      const currentOrderId =
        (this.order && this.order.id) || this.$route.params.id;
      return (
        currentOrderId != null &&
        String(currentOrderId) === String(managedOrder.id)
      );
    },
    // FIXME:
    // - use correct UI instead of select
    onClickDelete () {
      this.selectValue = "削除";
      this.centerDialogVisible = true;
    },
    sendOrderVisibleFunc () {
      this.sendOrderVisible = true;
      // this.isLoading = true;
    },
    sendOrderModalCancel () {
      this.sendOrderVisible = false;
      this.isLoading = false;
    },
    async onSubmitSignature (imageUrl) {
      // APIに保存の処理が必要になる。
      const loading = this.$loading();
      try {
        // save it
        const res = await this.saveSignature(imageUrl);
        if (res.errors) {
          throw new Error(res.errors[0].message);
        }
        // it succeed, so I notify it
        const message = "サインを更新しました";
        this.$notify({ message });
        if (this.primaryOrder.detail) {
          this.primaryOrder.detail.signature = imageUrl;
        }
      } catch (err) {
        console.log(err);
        const message = "サインの更新に失敗しました。再度お試しください";
        this.$notify({ message });
      } finally {
        loading.close();
      }
    },
    async saveSignature (imageUrl) {
      const param = {
        orderId: this.primaryOrder.id,
        order: {
          detail: {
            signature: imageUrl,
          },
        },
      };
      const res = await usecase.order.orderUpdate(param);
      return res;
    },
    async deleteOrder () {
      const orderId = this.primaryOrder && this.primaryOrder.id
        ? this.primaryOrder.id
        : this.$route.params.id;
      const param = { orderId };
      const result = await usecase.order.orderDelete(param);
      this.centerDialogVisible = false;
      if (result.errors) {
        alert(result.errors[0].message);
        return;
      }
      this.$notify({
        message: "注文の削除を行いました。",
      });
      this.$router.push("/home");
    },
    async requestCancelOrder () {
      const orderId = this.primaryOrder.id;
      const param = { orderId, status: "CANCEL_REQUEST" };
      const result = await usecase.order.orderUpdateStatus(param);
      this.cancelDialogVisible = false;
      if (result.errors) {
        alert(result.errors[0].message);
        return;
      }

      this.$notify({
        message: "注文のキャンセル依頼を行いました。",
      });
      this.cancelOrder = true;
      this.syncOrder();
    },
    async sendOrder () {
      const orderId = this.primaryOrder.id;
      const updateStatus = "PROCESSING";
      if (this.primaryOrder && this.primaryOrder.detail) {
        // モーダルの希望納期入力は Vuex form に入るため、送信元の primaryOrder に同期する
        this.primaryOrder.detail.expectedShippingDate =
          this.form && this.form.expectedShippingDate
            ? this.form.expectedShippingDate
            : null;
      }
      this.primaryOrder.updateStatus(updateStatus);
      const payload = this.primaryOrder.orderCreatePayload;
      payload.orderId = orderId;
      delete payload.order.parentOrderId;
      // 注文詳細画面の送信では子注文同期を行わない。
      // childOrders: [] が含まれるとサーバー側で既存子注文が削除されるため除外する。
      delete payload.order.childOrders;

      this.isLoading = true;
      if (payload) {
        const res = await usecase.order.orderUpdate(payload);

        this.sendOrderVisible = false;
        this.isLoading = false;
        if (res.errors) {
          this.$notify({
            message: res.errors.reduce(
              (acc, cur) => `${acc} ${cur.message}`,
              ""
            ),
            customClass: "error-message",
          });
          return;
        }
        this.$notify({
          message: "注文の送信を行いました。",
        });
        this.syncOrder();
      }
    },

    /**
     * 種類のテキストを生成します。預かり位牌であれば azukariProductSize または「フリー」、それ以外であれば size を出力します。
     * @return {string} 種類のテキスト
     */
    getSizeText () {
      const {
        product,
        productVariation,
        azukariProductSize,
      } = this.order.detail;
      const size = productVariation ? productVariation.size : "サイズ未指定";
      const isAzukariIhaiProduct = product.category.id === "99000";

      // 預かり位牌の場合
      if (isAzukariIhaiProduct) {
        return azukariProductSize || size;
      }

      return size;
    },

    /* 注文を送信しますか？のダイアログを閉じた場合、希望納期をリセットする  */
    closedSendOrderVisible () {
      this.resetDetailInput();
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.order = new OrderUsecase();
    usecase.file = new FileUsecase();
    // usecase.product = new ProductUsecase();
    // usecase.orderForm = new OrderFormUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.contentContainer {
  height: 100%;
  overflow: auto;
}
.hideDialog {
  display: none !important;
}
.Toolbar {
  display: flex;
  align-items: center;
  padding: 10px;
}
.Toolbar-Left {
  flex: 1;
  justify-content: center;
  align-items: center;
}
.Toolbar-Center {
  flex: 1;
  justify-content: center;
  align-items: center;
  padding-right: 8rem;
}
.Toolbar-Right {
  margin-bottom: 5px;
}

.alertNoteBox {
  margin: 5px;
  color: red;
}

.preview {
  text-align: center;
  margin-top: 2rem;
}
.tablet {
  width: 350px;
}
.image_area {
  width: 350px;
  height: 550px;
}
.title {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
}
.Contents {
  padding-bottom: 20px;
}
.preview-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  margin-left: 1rem;
}
.two-title {
  display: flex;
  padding: 0 7rem;
  font-size: 1.2rem;
}
.title-left {
  flex: 1;
  margin: 0;
  float: left;
  font-weight: bold;
}
.title-right {
  flex: 1;
  margin: 0;
  float: right;
  font-weight: bold;
}
.product-data {
  margin: 0 0.3rem 0;
}
.data-inline {
  display: inline-block;
}
.box {
  width: 80%;
  margin: auto;
}
.black-text {
  color: black;
  width: 100%;
  text-align: left;
}
.cancel-request {
  display: inline-block;
  line-height: 1;
  background: white;
  border: 1px solid $red-base;// #ec705b;
  color: $red-base; // #ec705b;
  box-sizing: border-box;
  margin: 0;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.red-text {
  color: red;
  align-items: center;
  width: 100%;
  text-align: left;
}
.redText {
  color: red;
  align-items: center;
}
.el-select-dropdown__item {
  padding: 0px !important;
}
</style>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

.Toolbar-Right .Toolbar-Right-Div1 {
  float: left;
  margin-left: 5px;
}
.Toolbar-Right .Toolbar-Right-Div2 {
  float: right;
  margin-right: 5px;
}
.Toolbar-Right .el-input--suffix .el-input__inner {
  text-align: center !important;
}
.Toolbar-Right .el-input__suffix {
  right: 0 !important;
  left: 5px !important;
  padding-left: 0.2px !important;
}
.Toolbar-Right .el-select .el-input .el-select__caret {
  float: left !important;
  color: black !important;
  font-size: 20px !important;
  margin-top: 0.1rem !important;
}
.Toolbar-Right .el-select .el-input .el-select__caret.is-reverse {
  margin-top: -0.1rem !important;
}
.Toolbar-Right .el-select {
  width: 100px !important;
  padding-right: 5px !important;
}
.Toolbar-Right .el-select .el-input.is-focus .el-input__inner {
  border-color: $--border-color-light !important;
}
.Toolbar-Right .el-select .el-input__inner:focus {
  border-color: $--border-color-light !important;
}
.Toolbar-Center-Text {
  width: 400px;
  text-align: center;
  font-weight: bold;
}
.cancel-btn {
  margin-right: 5rem;
}
.sendcompletebtn {
  margin-right: 0.5rem;
}
@media (max-width: 1120px) {
  .Toolbar-Center {
    padding-right: 0.1rem !important;
  }
  .Toolbar-Center-Text {
    width: 330px;
    text-align: left;
  }
}
@media (max-width: 1120px) {
  .Toolbar-Left {
    width: 200px;
  }
}
@media (max-width: 768px) {
  .Toolbar-Right {
    width: 383px !important;
  }
  .cancel-request {
    padding: 12px 7px !important;
  }
  .request-btn-padding {
    padding: 12px 12px !important;
  }
  .sendbtn {
    float: right;
  }
  // .selectbtn {
  // }
  .sendcompletebtn {
    padding: 12px 6px !important;
    width: 100px !important;
    float: right !important;
    margin-right: 5px !important;
  }
  .Toolbar-Right .Toolbar-Right-Div2 {
    width: 210px;
  }
  .Toolbar-Right .el-select {
    width: 5rem !important;
    padding-right: 0rem !important;
  }
  .Toolbar-Right .el-input--suffix .el-input__inner {
    width: 100px !important;
  }
  .Toolbar-Right .el-input--suffix .el-input__inner {
    padding-right: 10px !important;
  }
  .Toolbar-Center {
    padding-right: 0.8rem !important;
  }
  .Toolbar-Center-Text {
    width: 240px;
    text-align: left;
  }
}
.order-dialog .dialog-text {
  font-size: 17px;
  font-weight: bold;
}
.order-dialog .el-dialog--center .el-dialog__body {
  text-align: center;
  padding-bottom: 5rem;
  padding-top: 5rem;
}
.order-dialog .el-button {
  border: none;
}
.order-dialog .el-dialog__close {
  display: none;
}
.Flow > * {
  margin-right: 10px;
  margin-left: 10px;
}
.Flow > * + * {
  margin-top: 30px;
}
.sendbtn {
  margin-right: 0.5rem !important;
}
.Text {
  font-size: 18px;
}
.statusAndAuthorTable {
  width: 100%;
  border-top: 1px solid $--border-color-lighter;
}
.statusAndAuthorTable th,
.statusAndAuthorTable td {
  text-align: left;
  border-bottom: 1px solid $--border-color-lighter;
  padding: 10px 5px;
}
.statusAndAuthorTable td {
  width: 70%;
}
.statusAndAuthorTable th {
  color: $--color-primary;
}
.orderInformation {
  white-space: pre-wrap;
}
#print-btn {
  padding-left: 10px;
}
#operation-btn {
  width: 100%;
  text-align: left;
  padding-left: 10px;
}
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}
.UserUploadImgConfirm {
  width: 50%;
  margin-left: 100px;
}
.UserUploadImgTitleConfirm {
  font-size: 12px;
  font-weight: bold;
  margin-left: 20px;
}
.error-message .el-notification__content p {
  color: #ff4500
}
.order-management-dialog-body {
  min-height: 160px;
}
.order-management-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}
.order-management-item {
  width: 360px;
  max-width: 100%;
  text-align: center;
}
.order-management-preview-frame {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 12px 10px;
  background: #fff;
}
/* OrderFormStep3 .isActiveProduct / 注文作成の編集中プレビューと同じ */
.order-management-preview-frame.order-management-preview-frame--current {
  border: 3px solid $blue-deep;
}
/* Confirmed: approved layout standalone section */
.approved-layout-confirmed {
  text-align: center;
  padding: 16px 0;
}
.approved-layout-confirmed-img {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.approved-layout-confirmed-img:hover {
  opacity: 0.85;
}

/* Layout Images */
.layout-images-section {
  padding: 0 20px;
  margin-bottom: 20px;
}
.layout-description {
  font-size: 13px;
  margin-bottom: 16px;
}
.layout-images-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-start;
}
.layout-image-card {
  width: 180px;
  cursor: pointer;
  text-align: center;
}
.layout-image-card-inner {
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 8px;
  transition: border-color 0.2s;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: #fff;
}
.layout-image-card:hover .layout-image-card-inner {
  border-color: #409eff;
}
.layout-image-card.layout-image-approved .layout-image-card-inner {
  border-color: #67c23a;
  border-width: 2px;
}
.layout-image-thumb-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.layout-image-thumb {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.layout-image-approved-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #67c23a;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  z-index: 2;
}
.layout-image-approved-badge i {
  font-weight: bold;
}
.layout-image-filename {
  font-size: 12px;
  color: #333;
  margin-top: 6px;
  word-break: break-all;
}
/* Layout Image Dialog */
.layout-image-dialog .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}
.layout-image-dialog .el-dialog__header {
  padding: 16px 24px;
  border-bottom: 1px solid #ebeef5;
  background: #fafafa;
}
.layout-image-dialog .el-dialog__body {
  padding: 20px 24px;
}
.layout-image-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}
.layout-image-dialog-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #303133;
  font-size: 18px;
  font-weight: bold;
  user-select: none;
  transition: color 0.2s;
}
.layout-image-dialog-header-title:hover {
  color: #409eff;
}
.layout-image-dialog-header-title i {
  font-size: 22px;
}
.layout-image-dialog-header-label {
  letter-spacing: 1px;
}
.layout-image-dialog-content {
  padding: 0;
}
.layout-image-dialog-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  margin-top: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}
.layout-image-dialog-filename {
  font-size: 15px;
  color: #606266;
  margin: 0;
  font-weight: 500;
}
.layout-image-dialog-preview {
  text-align: center;
  margin-top: 16px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
}
.layout-image-full {
  max-width: 100%;
  max-height: 55vh;
  object-fit: contain;
}
.layout-image-dialog-thumbs {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
  padding: 16px 0 4px;
  border-top: 1px solid #ebeef5;
  flex-wrap: wrap;
}
.layout-image-dialog-thumb-item {
  width: 72px;
  height: 72px;
  border: 2px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  transition: all 0.2s;
  padding: 4px;
  box-sizing: border-box;
}
.layout-image-dialog-thumb-item:hover {
  border-color: #409eff;
  transform: translateY(-2px);
}
.layout-image-dialog-thumb-item img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.layout-image-dialog-thumb-selected {
  border-color: #409eff;
  box-shadow: 0 0 6px rgba(64, 158, 255, 0.4);
}
</style>
